var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiclogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 513.033,
    height: 108,
    viewBox: "0 0 513.033 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(-0.774 0.015)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-Page-Design-Increased-sizes",
    transform: "translate(0.774 -0.015)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Primary-Navigation",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Image",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-90",
    transform: "translate(0 5.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-21",
    d: "M31.045,24.029a8.7,8.7,0,0,0-7.272,3.983V50.589h7.272Z",
    transform: "translate(34.63 34.904)",
    fill: "#cc1521",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-23",
    d: "M37.249,31.907a5.508,5.508,0,0,1,1.028-.947A5.829,5.829,0,0,1,41.58,30h0a5.838,5.838,0,0,1,3.3.955,5.565,5.565,0,0,1,1.032.951A8.374,8.374,0,0,1,47.525,37.5a14.768,14.768,0,0,1-.354,3.163,6.451,6.451,0,0,1-1.239,2.686,5.419,5.419,0,0,1-4.35,1.908,5.419,5.419,0,0,1-4.348-1.906A6.44,6.44,0,0,1,36,40.669a15.188,15.188,0,0,1-.343-3.167c0-2.533.509-4.312,1.6-5.594M29.781,45.06a11.181,11.181,0,0,0,4.465,4.621A13.628,13.628,0,0,0,41.3,51.336h.571a13.633,13.633,0,0,0,7.052-1.656,11.15,11.15,0,0,0,4.463-4.621,14.19,14.19,0,0,0,1.292-4.11,20.385,20.385,0,0,0,.266-3.559c0-4.272-1.193-7.631-3.542-9.988a11.385,11.385,0,0,0-6.719-3.326,20.737,20.737,0,0,0-2.981-.229l-.113,0-.121,0a20.539,20.539,0,0,0-2.974.229A11.39,11.39,0,0,0,31.767,27.4c-2.351,2.356-3.542,5.715-3.542,9.983a21.48,21.48,0,0,0,.264,3.563,14.1,14.1,0,0,0,1.292,4.11",
    transform: "translate(41.216 34.637)",
    fill: "#cc1521",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-25",
    d: "M112.853,39.812l2.9-10.111,3.238,10.111Zm4.685-15.784a8.761,8.761,0,0,0-7.5,4.028L101.8,50.59h7.824l1.6-5.5h9.342l1.775,5.5h7.59l-9.75-26.562Z",
    transform: "translate(150.106 34.903)",
    fill: "#252b5f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-27",
    d: "M98.6,29.307h3.96a4.912,4.912,0,0,1,3.3.959,2.706,2.706,0,0,1,.936,2.194,3.6,3.6,0,0,1-.584,2.012c-.676.874-1.813,1.247-3.8,1.247H98.6Zm7.067,16.062a30.242,30.242,0,0,1,1.271,5.223h7.774a32.312,32.312,0,0,0-1.5-4.867c-1.534-3.684-3.736-4.9-4.373-5.181a1.323,1.323,0,0,0-.525-.117l0-.342a2.377,2.377,0,0,0,.515-.1,7.424,7.424,0,0,0,4.088-3.849,10.239,10.239,0,0,0,.674-4.858,7.907,7.907,0,0,0-1.467-4.235,6.255,6.255,0,0,0-3.383-2.36,20.646,20.646,0,0,0-5.968-.655H98.81a8.745,8.745,0,0,0-7.529,3.989V50.592H98.6V40.921h1.042a6.615,6.615,0,0,1,6.024,4.448Z",
    transform: "translate(134.542 34.903)",
    fill: "#252b5f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-29",
    d: "M12.143,51.069h1.333c3.437,0,6.315-.267,9.451-3.624,1.658-1.779,2.466-4.239,2.466-7.521V24.029a8.853,8.853,0,0,0-7.274,3.985V39.9a5.163,5.163,0,0,1-1.438,3.689,5.427,5.427,0,0,1-3.872,1.345,5.427,5.427,0,0,1-3.872-1.345A5.17,5.17,0,0,1,7.5,39.9V24.029A8.628,8.628,0,0,0,.224,28.014v11.91c0,3.2.829,5.734,2.466,7.521,3.232,3.528,6.395,3.578,9.453,3.624",
    transform: "translate(-0.223 34.904)",
    fill: "#cc1521",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-31",
    d: "M37.093,50.594V24.028c-2.778.025-5.2,1.368-7.217,4V39.77l-.314-.469L19.277,24.034a8.807,8.807,0,0,0-7.295,3.987V50.594h7.2V34.976l10.55,15.617Z",
    transform: "translate(17.18 34.902)",
    fill: "#cc1521",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-33",
    d: "M65.637,50.594V24.028c-2.778.025-5.2,1.368-7.217,4V39.77L58.1,39.3,47.821,24.034a8.807,8.807,0,0,0-7.295,3.987V50.594h7.2V34.976l10.55,15.617Z",
    transform: "translate(59.425 34.902)",
    fill: "#cc1521",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-35",
    d: "M82.025,50.594V24.028c-2.778.025-5.206,1.368-7.217,4V39.77l-.316-.469L64.209,24.034a8.807,8.807,0,0,0-7.295,3.987V50.594h7.2V34.976l10.55,15.617Z",
    transform: "translate(83.68 34.902)",
    fill: "#252b5f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-37",
    d: "M159.265,29.305V24.028H145.588a8.535,8.535,0,0,0-7.469,3.989V50.59h21.146V45.352H145.322V39.9h12.936V34.631H145.322V29.305Z",
    transform: "translate(203.864 34.903)",
    fill: "#252b5f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-39",
    d: "M139.31,50.594V24.028c-2.776.023-5.2,1.366-7.217,4V39.77l-.316-.469L121.495,24.034a8.807,8.807,0,0,0-7.295,3.987V50.594h7.2V34.976l10.55,15.617Z",
    transform: "translate(168.463 34.902)",
    fill: "#252b5f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-41",
    d: "M59.59,24.029a8.7,8.7,0,0,0-7.274,3.983V50.589H59.59Z",
    transform: "translate(76.874 34.904)",
    fill: "#252b5f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-43",
    d: "M80.441,51.348a14.356,14.356,0,0,0,6.077-1.13,8.691,8.691,0,0,0,3.87-3.232,7.688,7.688,0,0,0,1.21-4.477,6.4,6.4,0,0,0-.978-3.5,7.212,7.212,0,0,0-3.113-2.834,32.275,32.275,0,0,0-7.534-2.3,6.816,6.816,0,0,1-2.935-1.209,2.1,2.1,0,0,1-.7-1.543,1.963,1.963,0,0,1,.787-1.653,3.7,3.7,0,0,1,2.443-.694,5.488,5.488,0,0,1,3.282.959,3.062,3.062,0,0,1,1.317,2.058h6.962a7.8,7.8,0,0,0-3.054-5.8,12.923,12.923,0,0,0-7.688-2.152c-3.113,0-4.948.275-6.548.98a7.683,7.683,0,0,0-3.42,2.873,6.9,6.9,0,0,0-1.151,3.8A5.689,5.689,0,0,0,71.5,36.1a18.684,18.684,0,0,0,7.667,3.228c2.3.511,3.736,1.051,4.4,1.649a3.376,3.376,0,0,1,1.015,2.39,2.353,2.353,0,0,1-.925,2.016,4.724,4.724,0,0,1-3.088.917,4.673,4.673,0,0,1-5.04-4.306H68.61a10.034,10.034,0,0,0,2.822,6.491c1.878,1.9,4.909,2.867,9.009,2.867",
    transform: "translate(100.989 34.626)",
    fill: "#252b5f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-45",
    d: "M91.386,51.069h1.333c3.437,0,6.315-.267,9.451-3.624,1.658-1.779,2.466-4.239,2.466-7.521V24.029a8.853,8.853,0,0,0-7.274,3.985V39.9a5.163,5.163,0,0,1-1.438,3.689,6.248,6.248,0,0,1-7.745,0,5.169,5.169,0,0,1-1.44-3.689V24.029a8.628,8.628,0,0,0-7.272,3.985v11.91c0,3.2.829,5.734,2.466,7.521,3.23,3.528,6.395,3.578,9.453,3.624",
    transform: "translate(117.058 34.904)",
    fill: "#252b5f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-47",
    d: "M127.4,45.06a11.168,11.168,0,0,0,4.465,4.621,13.628,13.628,0,0,0,7.052,1.656h.569a13.641,13.641,0,0,0,7.054-1.656A11.163,11.163,0,0,0,151,45.06a14.253,14.253,0,0,0,1.291-4.11c.025-.142.048-.286.067-.425h-7.54a6.586,6.586,0,0,1-1.271,2.825,5.912,5.912,0,0,1-8.7,0,6.415,6.415,0,0,1-1.239-2.684,15.134,15.134,0,0,1-.343-3.167c0-2.535.509-4.312,1.6-5.594a5.433,5.433,0,0,1,1.028-.947,6.182,6.182,0,0,1,6.608,0,5.609,5.609,0,0,1,1.03.951,6.349,6.349,0,0,1,1.3,2.661h7.534a12.333,12.333,0,0,0-3.351-7.164,11.373,11.373,0,0,0-6.717-3.326,20.718,20.718,0,0,0-2.981-.229l-.113,0-.121,0a20.561,20.561,0,0,0-2.977.229,11.384,11.384,0,0,0-6.721,3.326c-2.351,2.356-3.542,5.713-3.542,9.983a21.481,21.481,0,0,0,.264,3.563,14.042,14.042,0,0,0,1.292,4.11",
    transform: "translate(185.696 34.637)",
    fill: "#252b5f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-49",
    d: "M23.7,23.569h7.274V17.662A8.691,8.691,0,0,0,23.7,21.617Z",
    transform: "translate(34.527 25.48)",
    fill: "#252b5f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-51",
    d: "M52.978,9.642v1.952H60.25V5.686a8.68,8.68,0,0,0-7.272,3.955",
    transform: "translate(77.853 7.756)",
    fill: "#252b5f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-53",
    d: "M121.439,11.332v1.952h7.274V7.376a8.684,8.684,0,0,0-7.274,3.955",
    transform: "translate(179.177 10.258)",
    fill: "#cc1521",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-55",
    d: "M79.707,15.063a3.163,3.163,0,0,1,.59-.546,3.434,3.434,0,0,1,1.934-.555h0a3.439,3.439,0,0,1,1.928.55,3.4,3.4,0,0,1,.6.55,5.2,5.2,0,0,1,.961,3.451,9.613,9.613,0,0,1-.226,2.031,3.848,3.848,0,0,1-.726,1.6,3.476,3.476,0,0,1-5.072,0,3.9,3.9,0,0,1-.728-1.6,9.825,9.825,0,0,1-.218-2.035,5.127,5.127,0,0,1,.957-3.451ZM57.243,26.587l.111.092c2.784,2.321,5.528,2.365,8.18,2.4h16.9a10.394,10.394,0,0,0,5.382-1.272,8.624,8.624,0,0,0,3.456-3.576,10.827,10.827,0,0,0,.99-3.134,15.375,15.375,0,0,0,.2-2.679,10.36,10.36,0,0,0-2.727-7.617,8.759,8.759,0,0,0-5.179-2.565,15.124,15.124,0,0,0-2.236-.173h-.176a15.586,15.586,0,0,0-2.238.171,8.785,8.785,0,0,0-5.181,2.567A10.364,10.364,0,0,0,72,18.42a16.175,16.175,0,0,0,.2,2.675,12.617,12.617,0,0,0,.383,1.633l.067.221H66.2a5.426,5.426,0,0,1-3.872-1.343,5.144,5.144,0,0,1-1.438-3.582h0l0-.108V10.728a8.847,8.847,0,0,0-7.272,3.97v3.219a5.161,5.161,0,0,1-1.44,3.689A5.426,5.426,0,0,1,48.3,22.949H30.684a5.428,5.428,0,0,1-3.875-1.343,5.107,5.107,0,0,1-1.417-3.19V10.728a8.864,8.864,0,0,0-7.272,3.985V26.6a5.156,5.156,0,0,1-1.44,3.686,5.414,5.414,0,0,1-3.872,1.345,5.414,5.414,0,0,1-3.872-1.345A5.161,5.161,0,0,1,7.5,26.6V14.8A8.633,8.633,0,0,0,.224,18.791v7.832c0,3.2.829,5.734,2.466,7.521,3.23,3.524,6.393,3.576,9.453,3.624h1.333c3.437,0,6.315-.267,9.453-3.624a9.372,9.372,0,0,0,2.334-5.394l.025-.2.19.054a17.9,17.9,0,0,0,4.54.475h18.95c2.981,0,5.476-.175,8.164-2.4Z",
    transform: "translate(-0.224 11.281)",
    fill: "#252b5f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-57",
    d: "M48.718,11.332v1.952h7.272V7.376a8.677,8.677,0,0,0-7.272,3.955",
    transform: "translate(71.548 10.258)",
    fill: "#252b5f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-59",
    d: "M143.713,9.594V32.2h7.274V5.639a8.681,8.681,0,0,0-7.274,3.955",
    transform: "translate(212.143 7.686)",
    fill: "#cc1521",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-61",
    d: "M26.67,17.662A8.7,8.7,0,0,0,19.4,21.617v1.952H26.67Z",
    transform: "translate(28.151 25.48)",
    fill: "#252b5f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-63",
    d: "M3.805,11.332v1.952h7.274V7.376a8.683,8.683,0,0,0-7.274,3.955",
    transform: "translate(5.077 10.258)",
    fill: "#252b5f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-65",
    d: "M139.348,5.641a8.618,8.618,0,0,0-7.243,3.983v9.5h7.278V5.639a.216.216,0,0,1-.036,0",
    transform: "translate(194.963 7.686)",
    fill: "#cc1521",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-67",
    d: "M38.455,9.743l8.612,0A2.253,2.253,0,0,0,49.2,7.614l0-1.211H46.5a5.439,5.439,0,0,1-.827-.092.651.651,0,0,1-.08-.015,1.149,1.149,0,0,1-.27-.09.961.961,0,0,1-.23-.173,1.209,1.209,0,0,1-.287-.419,1.352,1.352,0,0,1,0-1.053,1.178,1.178,0,0,1,.272-.4,1.025,1.025,0,0,1,.245-.188,1.464,1.464,0,0,1,.354-.106,5.961,5.961,0,0,1,1.176-.092h1.43V.266L46.336.272a8.484,8.484,0,0,0-1.413.14,5.107,5.107,0,0,0-1.292.43,4.483,4.483,0,0,0-1.164.851,4.321,4.321,0,0,0-1.551,3.4A5.586,5.586,0,0,0,41.026,6.2l.042.206H40.6a2.254,2.254,0,0,0-2.148,2.248Z",
    transform: "translate(56.36 -0.266)",
    fill: "#252b5f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-69",
    d: "M77.134,30.274l.109-.09.111.09c2.786,2.321,5.53,2.365,8.182,2.4h1.331c2.983,0,5.478-.177,8.168-2.4l.109-.092.111.092c2.786,2.321,5.53,2.365,8.182,2.4h1.335c3.437,0,6.315-.265,9.451-3.624,1.658-1.777,2.464-4.237,2.464-7.521V5.638a8.869,8.869,0,0,0-7.272,3.985V21.512a5.164,5.164,0,0,1-1.438,3.689,6.255,6.255,0,0,1-7.745,0,5.157,5.157,0,0,1-1.44-3.689V5.638l-.059,0a8.461,8.461,0,0,0-6.349,2.884,10.156,10.156,0,0,0-.871,1.1V21.512a5.17,5.17,0,0,1-1.44,3.689,6.258,6.258,0,0,1-7.747,0,5.148,5.148,0,0,1-1.436-3.572h0l0-.119V14.878a8.85,8.85,0,0,0-7.272,3.97v2.665a5.157,5.157,0,0,1-1.44,3.689A5.419,5.419,0,0,1,68.3,26.544H51.771A5.432,5.432,0,0,1,47.9,25.2a5.168,5.168,0,0,1-1.438-3.689V5.638a8.623,8.623,0,0,0-7.272,3.985v11.91c0,3.2.829,5.736,2.466,7.523,3.228,3.524,6.393,3.574,9.451,3.622H68.969c2.983,0,5.476-.175,8.166-2.4",
    transform: "translate(57.442 7.686)",
    fill: "#252b5f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-71",
    d: "M72.368,25.686a6.443,6.443,0,0,0-.756,3H84.856c.394,0,.791-.017,1.187-.052a11.142,11.142,0,0,0,5.714-2.068,12.185,12.185,0,0,0,2.016-1.985,9.915,9.915,0,0,0,2.135-6.043V18.5a9.933,9.933,0,0,0-2.135-6.045,11.864,11.864,0,0,0-2.016-1.983,11.668,11.668,0,0,0-6.9-2.121H81a9.765,9.765,0,0,0-3.023,2.957,6.142,6.142,0,0,0-.758,2.961h7.615a5.011,5.011,0,0,1,3.575,1.3,4.339,4.339,0,0,1,0,5.9,4.956,4.956,0,0,1-3.575,1.245l-9.447.017a9.751,9.751,0,0,0-3.021,2.955",
    transform: "translate(105.432 11.697)",
    fill: "#cc1521",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-73",
    d: "M83.325,9.624v11.91c0,3.2.829,5.734,2.466,7.523a10.275,10.275,0,0,0,7.391,3.624l90.532,0c3.437,0,6.315-.265,9.451-3.624,1.66-1.777,2.466-4.237,2.466-7.521V14.879a8.85,8.85,0,0,0-7.272,3.97v2.665a5.161,5.161,0,0,1-1.44,3.689,5.414,5.414,0,0,1-3.849,1.343H160.787l.075-.225a10.224,10.224,0,0,0-1.7-9.625,12.711,12.711,0,0,0-2.127-2.1,12.334,12.334,0,0,0-7.289-2.239h-9.62a10.3,10.3,0,0,0-3.2,3.126,5.883,5.883,0,0,0-.8,2.95l13.6,0a5.2,5.2,0,0,1,3.7,1.435,4.991,4.991,0,0,1,.044,6.61l-.05.063H95.909A5.419,5.419,0,0,1,92.037,25.2a5.161,5.161,0,0,1-1.44-3.689V5.638a8.627,8.627,0,0,0-7.272,3.987",
    transform: "translate(122.767 7.685)",
    fill: "#cc1521",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-75",
    d: "M138.909,30.28c2.784,2.314,5.526,2.358,8.176,2.4h1.333c3.437,0,6.317-.265,9.451-3.624,1.66-1.777,2.464-4.237,2.464-7.521V5.638a8.863,8.863,0,0,0-7.27,3.985V21.512a5.17,5.17,0,0,1-1.44,3.689,5.414,5.414,0,0,1-3.872,1.343,5.755,5.755,0,0,1-3.956-1.224,3.986,3.986,0,0,1-1.342-2.677h-7.291a3.828,3.828,0,0,1-1.325,2.65,5.786,5.786,0,0,1-3.8,1.251v6.134h.5c2.979,0,5.472-.175,8.157-2.4l.109-.092Z",
    transform: "translate(191.9 7.686)",
    fill: "#cc1521",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-77",
    d: "M125.676,9.642v1.952h7.274V5.686a8.681,8.681,0,0,0-7.274,3.955",
    transform: "translate(185.448 7.756)",
    fill: "#cc1521",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Logos_UnionInsurance-Mark",
    "data-name": "Logos/UnionInsurance-Mark",
    transform: "translate(386.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-79",
    d: "M45.818,34.907,33.15,22.288,45.818,9.669,58.484,22.288Z",
    transform: "translate(34.41 -9.669)",
    fill: "#252b5f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-81",
    d: "M82.186,45.9,52.627,16.453,39.961,29.072,56.849,45.9,39.961,62.722,52.627,75.341Z",
    transform: "translate(44.49 -0.082)",
    fill: "#252b5f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-83",
    d: "M39.008,41.69,26.339,29.071,39.008,16.454,51.676,29.071Z",
    transform: "translate(24.33 0.1)",
    fill: "#cc1521",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-85",
    d: "M65.978,23.238,49.087,40.062,32.2,23.238,19.529,35.857,49.087,65.3,78.644,35.857Z",
    transform: "translate(14.251 9.732)",
    fill: "#cc1521",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-87",
    d: "M98.8,88.591,86.137,76.13,69.245,92.745l-38-37.384,33.778-33.23L52.357,9.669,5.908,55.361l63.337,62.307Z",
    transform: "translate(-5.908 -9.669)",
    fill: "#252b5f",
    fillRule: "evenodd"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiclogo);
export default __webpack_public_path__ + "static/media/UICLOGO.2ed8494b8184a0f1add41b5ddf7aa865.svg";
export { ForwardRef as ReactComponent };